import React, { memo } from 'react'

import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { POLYGON_TYPE } from 'Pods/ThreeDStudio/Store/constants'

const labels = {
  [POLYGON_TYPE.QUADRILATERAL]: 'Quad',
  [POLYGON_TYPE.TRIANGLE]: 'Triangular',
}

function CollapsedPolygonTypeRow() {
  const polygonType = useThreeDStudioStore(state => state.modelSettings.polygonType)
  const buttonLabel = labels[polygonType] || ''
  const isActive = Boolean(buttonLabel)

  return (
    <ClosedButtonSettings
      label="Polygon Type"
      isActive={isActive}
      buttonLabel={buttonLabel}
    />
  )
}

export default memo(CollapsedPolygonTypeRow)
